module.exports = __webpack_public_path__ + "media/icons/arrow-right-2479c9f8.svg";